<template>
  <div class="box__victory">
    <div class="progress">
      <p>{{ $t("shop.victories_remain") }}</p>
      <span>{{ getUserProgress }}/{{ getProgressTarget }}</span>
    </div>
    <ProgressLine class="progress__line--white" :current="getProgressLine" />
  </div>
</template>
<script>
import ProgressLine from "../../Common/ProgressLine";
import { mapGetters } from "vuex";
export default {
  name: "ShopItemBuyVictory",
  components: {
    ProgressLine,
  },
  props: {
    boxContent: Object,
    victoryCurrency: String,
  },
  computed: {
    ...mapGetters("wallets", ["getWalletsState"]),
    getBoxCurrency() {
      return this.boxContent.conditions.currencies;
    },
    getUserProgress() {
      const user_progress = this.getWalletsState[this.victoryCurrency];
      return user_progress >= this.getProgressTarget ? this.getProgressTarget : user_progress;
    },
    getProgressTarget() {
      return this.getBoxCurrency.filter(item => item.currency === this.victoryCurrency)[0].amount;
    },
    getProgressLine() {
      return (this.getUserProgress / this.getProgressTarget) * 100;
    },
  },
};
</script>
